import * as Preact from "preact"
import App from "@fae/source/models/App.js"

import "@fae/source/views/components/DialogueLog.less"

export default class DialogueLog {
    render() {
        if(this.props.stage.events == undefined) return
        if(this.props.stage.events.length == 0) return
        // const dialogue = this.props.stage.dialogue
        // if(dialogue == undefined) return
        // const speaker = dialogue?.scene?.speakerName || dialogue?.scene?.speakerKey
        // <p class="LatestEvent">{speaker ? speaker + ": " : ""} {dialogue.text}</p>
        // if(isMaximized == true
        // || this.props.stage.dialogue != undefined
        if(this.props.stage.flags["log"] == true
        || App.game.chapter.selection.isRenderingDialogueLog == true) {
            return (
                <div class="DialogueLog">
                    <div class="MinimizeButton" onClick={(event) => App.game.chapter.selection.isRenderingDialogueLog = false}/>
                    <div class="Text">
                        {this.props.stage.events.map((event) => {
                            return <Event stage={this.props.stage} event={event}/>
                        })}
                    </div>
                </div>
            )
        } else {
            return (
                <div class="MinimizedDialogueLog">
                    <div class="MaximizeButton" onClick={(event) => App.game.chapter.selection.isRenderingDialogueLog = true}/>
                    <div class="Text">
                        <Event stage={this.props.stage} event={this.props.stage.events[this.props.stage.events.length - 1]}/>
                    </div>
                </div>
            )
        }
    }
}

class Event {
    render() {
        const event = this.props.event
        if(event == undefined) return
        if(event.dialogue != undefined) {
            return (
                <p class="DialogueEvent" isWhitespace={event.dialogue.text == " "}>{event.dialogue.text}</p>
            )
        }
        if(event.report != undefined) {
            return (
                <p class="ReportEvent" isFinisher={event.isFinisher}>{event.report instanceof Function ? event.report(this.props.stage) : event.report}</p>
            )
        }
    }
}
